module.exports = __webpack_public_path__ + "media/images/icon-problem-45ff3f4eebdfc7a7b1befeece3155661.svg";